
import { BehaviorSubject } from 'rxjs';

export const settingGlobalBehavior$ = new BehaviorSubject({});

export const settingGlobalBehavior = settingGlobalBehavior$.asObservable();